import { render, staticRenderFns } from "./EditEchipa.vue?vue&type=template&id=3225174a&scoped=true"
import script from "./EditEchipa.vue?vue&type=script&lang=js"
export * from "./EditEchipa.vue?vue&type=script&lang=js"
import style0 from "./EditEchipa.vue?vue&type=style&index=0&id=3225174a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3225174a",
  null
  
)

export default component.exports